import Config from 'Config';

import { createApiClient } from '../api-client-factory';
import { CountryResponse } from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/country`);

/**
 * Country API client.
 */
export const countryClient = {
  /**
   * Get country name for current user.
   */
  get: async () => client.get<CountryResponse>(''),
};
